{
  "api-enums-quoted": "Cotado",
  "api-enums-hired": "Contratado",
  "api-enums-simulated": "Simulado",
  "api-enums-to-be-renewed": "Renovação Futura",
  "api-enums-settled": "Liquidado",
  "api-enums-purchase": "Compra",
  "api-enums-sale": "Venda",
  "api-enums-import": "Importação",
  "api-enums-export": "Exportação",
  "api-enums-loan4131": "Repasse Externo (4131)",
  "api-enums-foreign_repass": "",
  "api-enums-indicative": "",
  "api-enums-open": "Em aberto",
  "api-enums-loan": "Empréstimo",
  "api-enums-credit-acquisition-acc": "Adiantamento sobre Contrato de Câmbio",
  "api-enums-credit-acquisition-ace": "Adiantamento sobre Cambiais Entregues",
  "api-enums-credit-acquisition-cdc": "CDC",
  "api-enums-credit-acquisition-ccb": "CCB",
  "api-enums-credit-acquisition-cce": "CCE",
  "api-enums-credit-acquisition-bndes": "BNDES",
  "api-enums-credit-acquisition-working-capital": "Capital de Giro",
  "api-enums-credit-acquisition-automaker-cdc": "CDC Automóvel",
  "api-enums-credit-acquisition-finimp": "Finimp",
  "api-enums-credit-acquisition-leasing": "Leasing",
  "api-enums-credit-acquisition-mutuo": "Mutuo",
  "api-enums-credit-acquisition-export-credit-note": "Nota de Crédito Exportação",
  "api-enums-credit-acquisition-external-transfer": "Transferência Externa",
  "api-enums-credit-acquisition-pre-export-payment": "Pagamento Antecipado Exportação",
  "api-enums-export-hedge": "Hedge Exportação",
  "api-enums-import-hedge": "Hedge Importação",
  "api-enums-low": "Baixo",
  "api-enums-medium": "Médio",
  "api-enums-high": "Alto",
  "api-enums-in-progress": "Em Andamento",
  "api-enums-completed": "Concluído",
  "api-enums-not-started": "Não Iniciado",
  "api-enums-open1": "Em aberto",
  "api-enums-overdue": "Atrasado",
  "api-enums-foreign-repass": "Repasse Externo (4131)",
  "api-enums-loan-operation-type-foreign-repass": "Repasse Externo (4131)",
  "api-enums-loan-operation-type-ace": "Adiantamento sobre Cambiais Entregues",
  "api-enums-loan-operation-type-acc": "Adiantamento sobre Contrato de Câmbio",
  "api-enums-loan-operation-type-bndes": "BNDES",
  "api-enums-loan-operation-type-working-capital": "Capital de Giro",
  "api-enums-loan-operation-type-manufacturer-financing": "CDC Montadora",
  "api-enums-loan-operation-type-direct-consumer-credit": "Crédito Direto ao Consumidor",
  "api-enums-loan-operation-type-bank-credit-note": "Cédula de Crédito Bancário",
  "api-enums-loan-operation-type-export-credit-ballot": "Cédula de Crédito de Exportação",
  "api-enums-loan-operation-type-finimp": "FINIMP",
  "api-enums-loan-operation-type-leasing": "Leasing",
  "api-enums-loan-operation-type-loan": "Mútuo",
  "api-enums-loan-operation-type-export-credit-note": "Nota de Crédito de Exportação",
  "api-enums-loan-operation-type-export-prepayment": "Pré-Pagamento de Exportação",
  "api-enums-bank-manager-position-general-manager": "Gerente Geral",
  "api-enums-bank-manager-position-relationship-manager": "Gerente de Relacionamento",
  "api-enums-bank-manager-position-business-manager": "Gerente de Negócios",
  "api-enums-bank-manager-position-corporate-manager": "Gerente Corporate",
  "api-enums-bank-manager-position-commercial-officer": "Officer Comercial",
  "api-enums-bank-manager-position-assistant-manager": "Gerente Assistente",
  "api-enums-bank-manager-position-client-specialist": "Especialista de Clientes",
  "api-enums-bank-manager-position-credit-analyst": "Analista de Crédito",
  "api-enums-bank-manager-position-credit-desk": "Mesa de Crédito",
  "api-enums-bank-manager-position-derivatives-desk": "Mesa de Derivativos",
  "api-enums-bank-manager-position-trader": "Trader",
  "api-enums-bank-manager-position-risk-analyst": "Analista de Risco",
  "api-enums-bank-manager-position-risk-manager": "Gerente de Risco",
  "api-enums-bank-manager-position-other": "Outro",
  "api-enums-within-band": "Dentro da Banda",
  "api-enums-attention": "Atenção",
  "api-enums-action-needed": "Ação Necessária",
  "api-enums-risk-event": "Evento de Risco",
  "api-enums-committee-decision": "Decisão de Comitê",
  "auth-welcome-message": "Seja bem vindo!",
  "auth-login-prompt": "Faça o login para começar.",
  "auth-field-email": "E-mail",
  "auth-field-password": "Senha",
  "auth-field-password-confirmation": "Confirme a senha",
  "auth-at-least8-characters": "Pelo menos 8 caracteres",
  "auth-at-least1-capital-letter": "Pelo menos 1 letra maiúscula (A-Z)",
  "auth-at-least1-number": "Pelo menos 1 número (0-9)",
  "auth-at-least1-symbol": "Pelo menos um símbolo (#$&)",
  "auth-to-define": "Definir",
  "auth-remember-password-message": "Lembrar senha neste dispositivo",
  "auth-sigin-button": "Acessar",
  "auth-last-password-label": "Perdeu a senha?",
  "auth-first-access-label-q": "Primeiro acesso?",
  "auth-first-access-label": "Primeiro acesso",
  "auth-define-password-to-access": "Defina sua senha para acessar o Cognito",
  "auth-login-validating-credentials": "Validando credenciais...",
  "auth-login-auth-success": "Autenticação realizada com sucesso!",
  "auth-login-getting-permissions": "Buscando permissões...",
  "auth-invalid-token-title": "Token inválido",
  "auth-invalid-token-message": "O token recebido na autenticação não é válido.",
  "auth-access-token-renewed-title": "Acesso renovado",
  "auth-access-token-renewed-success": "Token de autenticação renovado com sucesso",
  "auth-access-token-renewed-error": "Houve um erro ao renovar token de acesso, faça o login novamente",
  "auth-access-token-renewal-in-progress": "Seu token de acesso está próximo de expirar, renovação automática em andamento",
  "auth-access-token-renewal-title": "Renovação de acesso",
  "auth-recover-password-title": "Recuperação de senha",
  "auth-recover-password-success": "Se o endereço de email informado estiver correto, você receberá em instantes um link para criar uma nova senha",
  "auth-recover-password-instructions": "Insira seu e-mail para receber as instruções",
  "auth-password-created-successfully": "Senha criada com sucesso",
  "auth-password-updated-successfully": "Senha atualizada com sucesso",
  "auth-error-creating-password": "Erro ao criar senha",
  "auth-error-updating-password": "Erro ao atualizar senha",
  "auth-error-login": "Email ou Senha Inválido",
  "auth-confirm-send-password-recovery-email": "Tem certeza que deseja enviar o email de recuperação de senha para o usuário?",
  "auth-password-recovery-link1": "Link para recuperação de senha",
  "auth-additional-costs": "Custos adicionais",
  "calendar-january": "Janeiro",
  "calendar-february": "Fevereiro",
  "calendar-march": "Março",
  "calendar-april": "Abril",
  "calendar-may": "Maio",
  "calendar-june": "Junho",
  "calendar-july": "Julho",
  "calendar-august": "Agosto",
  "calendar-september": "Setembro",
  "calendar-october": "Outubro",
  "calendar-november": "Novembro",
  "calendar-december": "Dezembro",
  "calendar-confirm-cancel": "Tem certeza que deseja cancelar?",
  "calendar-create": "Criar",
  "comex-comex-control": "Comex",
  "comex-number-of-operations": "Número de operações",
  "comex-percentage-of-down-payments-made": "Percentual de pagamentos realizados",
  "comex-average-cost-of-lcs": "Custo médio das LCs",
  "comex-comex-operations": "Operações Comex",
  "comex-error-loading-kpis": "Erro ao carregar os KPIs",
  "comex-error-loading-comex-operations": "Erro ao carregar operações de comex",
  "comex-operation-updated-successfully1": "Operação Atualizada Com Sucesso",
  "comex-error-updating-operation1": "Erro Atualizando Operação",
  "comex-operation-created-successfully1": "Operação criada com sucesso",
  "comex-error-creating-operation1": "Erro Criando Operação",
  "comex-stage-saved-successfully": "Etapa salva com sucesso",
  "comex-error-saving-step": "Erro ao salvar etapa",
  "comex-reference1": "Referência",
  "comex-supplier": "Fornecedor",
  "comex-fob-value": "Valor FOB",
  "comex-tax-value": "Valor do Imposto (BRL)",
  "comex-freight-value": "Valor do Frete",
  "comex-foreign-currency-value": "Valor",
  "comex-comex-registration": "Cadastro Comex",
  "comex-negotiation-and-formalization": "Negociação e Formalização",
  "comex-financial-execution": "Execução Financeira",
  "comex-down-payment": "Down Payment",
  "comex-percentage": "Porcentagem",
  "comex-tax1": "Taxa de Câmbio",
  "comex-term": "Prazo",
  "comex-flow1": "Fluxo",
  "comex-payment-condition": "Condição de Pagamento",
  "comex-data-down-payment": "Data Down Payment",
  "comex-bank-down-payment": "Banco Pagador",
  "comex-data-de-atracacao": "Data de Atracação",
  "comex-shipping-date": "Data de Embarque",
  "comex-load-forecast": "Prontidão de Carga",
  "comex-real-value": "Valor",
  "comex-due-date-lc": "Data Vencimento da LC",
  "comex-lc-value": "Valor da LC",
  "comex-data-emissao": "Data Emissão",
  "comex-banco-lc": "Banco LC",
  "comex-payment-lc": "Data Pagamento LC",
  "comex-real-cost-lc": "Custo Nominal",
  "comex-annual-cost-flat-lc": "Custo Nominal Flat",
  "comex-attachment-lc": "Anexo LC",
  "comex-save-operation-first": "Salvar Primeiro a Operação",
  "comex-hedge-contratado": "Hedge Contratado",
  "comex-waiting-for-production": "Aguardando Produção",
  "comex-in-production": "Em Produção",
  "comex-awaiting-boarding": "Aguardando Embarque",
  "comex-in-transit": "Em Trânsito",
  "comex-registered1": "Registrado",
  "comex-completed1": "Finalizado",
  "comex-canceled": "Cancelado",
  "comex-save-step": "Salvar Parcialmente",
  "comex-budget-rate2": "Taxa de Orçamento",
  "comex-enter": "Digite...",
  "comex-save-data-confirmation": "Deseja salvar os dados preenchidos até agora? Você poderá retomar o preenchimento posteriormente.",
  "comex-save-partial-form": "Salvar Formulário Parcial",
  "comex-mandatory-fields-needs-to-be-filled": "Por favor, preencha todos os campos obrigatórios da negociação e Formalização",
  "comex-mandatory-fields-financial-execution": "Por favor, preencha todos os campos obrigatórios da execução financeira",
  "comex-required-fields-letter-of-credit": "Por favor, preencha todos os campos obrigatórios da LC(Letter of Credit)",
  "comex-partially-saved-successfully": "Parcialmente salvo com sucesso",
  "comex-real-value1": "Valor",
  "comex-load-readiness": "Prontidão de Carga",
  "comex-data-loss-warning1": "Todos os dados inseridos serão perdidos caso você não os tenha salvo parcialmente.",
  "comex-inform-currency": "Informe a Moeda",
  "comex-aprazo": "A Prazo",
  "comex-at-sight": "À Vista",
  "comex-load-forecast1": "Prontidão de Carga",
  "comex-payment-date": "Data do Pagamento",
  "comex-payment-bank": "Banco Pagador",
  "comex-add-payment": "Adicionar Pagamento",
  "comex-payment-installment": "Parcela de pagamento",
  "comex-confirm-deletion": "Confirmar Exclusão",
  "comex-operation-confirm-delete": "Ao confirmar, esta operação será permanentemente excluída. Deseja prosseguir?",
  "comex-operation-deleted-successfully": "Operação excluída com sucesso",
  "comex-negotiation": "Negociação",
  "comex-delete1": "Excluir",
  "comex-error-deleting-operation": "Erro ao Deletar a Operação",
  "comex-download-attachment": "Baixar Anexo LC",
  "comex-invoice": "Fatura",
  "comex-ref-trading": "Ref. Trading",
  "comex-early": "Antecipado",
  "comex-expiration-date": "Data de Vencimento",
  "comex-attention": "Atenção",
  "comex-negotiation-data-required": "Dados da negociação são obrigatórios",
  "comex-negotiation-attachments": "Anexos da negociação",
  "comex-bank-reference": "",
  "comex-bank-reference1": "Referência Banco",
  "comex-purchase-order": "Ordem de Compra (PO)",
  "comex-total-value": "Valor Total",
  "comex-status-parcela": "Status Parcela",
  "comex-average-payment-term": "Prazo médio de pagamento",
  "comex-comment": "Comentário",
  "comex-order-date": "Data da Ordem",
  "comex-container-quantity": "Quantidade de Containers",
  "comex-release-date": "Data de liberação",
  "comex-release-time": "Tempo de liberação",
  "comex-annual-cost1": "Custo a.a",
  "comex-flat-cost": "Custo Flat",
  "comex-are-you-sure-you-want-to-exit": "Tem certeza que deseja sair?",
  "comex-flat-opening-commission-rate": "Taxa de Comissão de Abertura Flat",
  "comex-opening-commission-rate-per-year": "Taxa de Comissão de Abertura a.a",
  "comex-comex-operation": "Operação de Comex",
  "comex-no-comex-operation-found": "Nenhuma operação de comex encontrada",
  "comex-product-value": "Valor do produto",
  "comex-bus-station": "Rodoviário",
  "comex-aereo": "Aéreo",
  "comex-maritime-lcl": "Marítimo LCL",
  "comex-maritimo-fcl": "Marítimo FCL",
  "control-currency-control": "Controle de câmbio",
  "control-official-exchange-rate": "Câmbio Oficial",
  "control-exchange-control": "Controle de Câmbio",
  "control-exchange-rates": "Taxas de Câmbio",
  "control-select-coins": "Selecione as Moedas",
  "control-recorded-operations": "Operações Registradas",
  "control-no-registered-operations": "Nenhuma Operação Cadastrada",
  "control-currency-registration": "Cadastro de Câmbio",
  "control-bank-ag-and-company-account": "Banco, AG e conta (da empresa)",
  "control-operation-date": "Data de operação",
  "control-operation-type2": "Tipo de operação",
  "control-foreign-payer-receiver-bank": "Banco pagador/recebedor exterior",
  "control-national-payer-receiver-bank": "Banco pagador/recebedor nacional",
  "control-payer-recipient-country-abroad": "País pagador/recebedor no exterior",
  "control-exchange-closed": "câmbio fechado",
  "control-delivery-date-of-exchange": "Data de entrega do câmbio",
  "control-foreign-currency-amount": "Montante da moeda estrangeira",
  "control-exchange-edited-successfully": "Câmbio editado com sucesso!",
  "control-exchange-registered-successfully": "Câmbio cadastrado com sucesso!",
  "control-file-deleted-successfully": "Arquivo excluído com sucesso!",
  "control-operation-successfully-deleted": "Operação excluída com sucesso!",
  "control-remove-exchange-operation": "Remover Operação de Cambio",
  "control-confirm-delete-operation": "Tem certeza que deseja excluir esta operação?",
  "control-data-operation": "Data Operação",
  "control-foreign-currency-value1": "Valor em Moeda Estrangeira",
  "control-valor-me": "Valor M.E.",
  "control-exchange-closed1": "Câmbio Fechado",
  "control-exchange-rate-closed": "Taxa de Câmbio Fechada",
  "control-converted-value": "Valor Convertido",
  "control-converted-value-in-national-currency": "Valor Convertido em Moeda Nacional",
  "control-total-in-national-currency": "Total em Moeda Nacional",
  "control-delivery-date-currency": "Data Entrega Câmbio",
  "control-delivery-date-of-exchange1": "Data de Entrega do Câmbio",
  "control-foreign-bank": "Banco no Exterior",
  "control-payer-or-receiver-bank-abroad": "Banco Pagador ou Recebedor no Exterior",
  "control-payer-or-receiver-in-foreign-country": "País Pagador ou Recebedor no Exterior",
  "control-operation-type3": "Tipo Operação",
  "control-beneficiary": "Beneficiário",
  "control-installment1": "Parcela",
  "control-loan-number-contract": "Número do Empréstimo (contrato)",
  "control-no-loan-found": "Nenhum empréstimo encontrado",
  "control-no-installment-found": "Nenhuma parcela encontrada",
  "costs-actions": "Ações",
  "costs-biological-asset": "Ativo Biológico",
  "costs-guarantee": "Garantia",
  "costs-guarantees": "Garantias",
  "costs-checks": "Cheques",
  "costs-customer-contract": "Contrato com Cliente",
  "costs-duplicates": "Duplicatas",
  "costs-financial-applications": "Aplicações Financeiras",
  "costs-equipment": "Equipamento",
  "costs-bank-guarantee": "Garantia Bancária",
  "costs-receivables-flow": "Fluxo de Recebíveis",
  "costs-real-estate": "Imóveis",
  "costs-raw-material": "Matéria-Prima",
  "costs-promissory-note": "Nota Promissória",
  "costs-credit-card-receivables": "Recebíveis de Cartão de Crédito",
  "costs-lease-guarantee": "Garantia Locatícia",
  "costs-surety-bond": "Fiança",
  "costs-vehicles": "Veículos",
  "costs-inventory": "Estoque",
  "costs-warrant": "Warrant",
  "costs-others": "Outros",
  "costs-remove-warranty": "Excluir garantia",
  "costs-confirm-delete-warranty": "Tem certeza que deseja excluir este garantia?",
  "costs-guarantee-excluded-successfully": "Garantia excluída com sucesso",
  "costs-warranty-management": "Gestão de garantias",
  "costs-register-warranty": "Cadastrar Garantia",
  "costs-no-registered-warranty": "Nenhuma Garantia Cadastrada",
  "costs-all-warranties": "Todas as Garantias",
  "costs-list-of-guarantees": "Lista de garantias",
  "costs-add-warranties": "Adicionar Garantias",
  "costs-reference-name": "Referência",
  "costs-add-name-to-guarantee": "Adicionar um nome à garantia",
  "costs-last-evaluation-date": "Data da última avaliação",
  "costs-guarantee-edited-successfully": "Garantia editada com sucesso!",
  "costs-guarantee-registered-successfully": "Garantia cadastrada com sucesso!",
  "costs-number-of-installments1": "",
  "costs-number-of-instalments": "Número de Parcelas",
  "costs-ace": "Adiantamento sobre Cambiais Entregues",
  "costs-acc": "Adiantamento sobre Contrato de Câmbio",
  "costs-bndes": "BNDES",
  "costs-working-capital": "Capital de Giro",
  "costs-manufacturer-financing": "CDC Montadora",
  "costs-direct-consumer-credit": "Crédito Direto ao Consumidor",
  "costs-bank-credit-note": "Cédula de Crédito Bancário",
  "costs-export-credit-ballot": "Cédula de Crédito de Exportação",
  "costs-finimp": "FINIMP",
  "costs-leasing": "Leasing",
  "costs-loan": "Mútuo",
  "costs-export-credit-note": "Nota de Crédito de Exportação",
  "costs-foreign-repass": "Repasse Externo (4131)",
  "costs-export-prepayment": "Pré-Pagamento de Exportação",
  "costs-commercial-note": "Nota Comercial",
  "costs-fixed-rate": "Taxa fixa",
  "costs-percent-of-libor": "% da LIBOR",
  "costs-percent-of-sofr": "% da SOFR",
  "costs-percent-of-euribor": "% da EURIBOR",
  "costs-liborplus-spread": "LIBOR + Spread",
  "costs-sofrplus-spread": "SOFR + Spread",
  "costs-euriborplus-spread": "EURIBOR + Spread",
  "costs-tjlp": "TJLP",
  "costs-tlp": "TLP",
  "costs-tfb": "TFB",
  "costs-selic-plus-rate": "Selic + taxa",
  "costs-pre": "PRE",
  "costs-cdiplus-rate": "CDI + taxa",
  "costs-percent-of-cdi": "% do CDI",
  "costs-percent-of-selic": "% da Selic",
  "costs-loans": "Empréstimos",
  "costs-currency-variation": "Variação Cambial (VC)",
  "costs-loan-details": "Detalhes",
  "costs-settle-instalment": "Liquidar",
  "costs-manage-derivatives": "Gerenciar Derivativos",
  "costs-link-derivative": "Vincular Derivativo",
  "costs-revert": "Reverter Liquidação",
  "costs-cannot-reverse-unsettled-installment": "Não é possível reverter uma parcela que não está liquidada",
  "costs-revert-payment": "Reverter Pagamento",
  "costs-reverse-payment-installment": "Deseja reverter o pagamento da parcela",
  "costs-payment-reverted-successfully": "Pagamento revertido com sucesso!",
  "costs-unable-to-reverse-unpaid-instalment": "Não é possível reverter uma parcela que não está liquidada",
  "costs-no-data-available": "Sem dados disponíveis",
  "costs-no-results-found": "Nenhum resultado encontrado",
  "costs-entries": "Entradas",
  "costs-last-payment": "Último pagamento",
  "costs-total-installments": "Total das parcelas",
  "costs-summary-card-operations-tooltip-open": "Quantidade de empréstimos em aberto: inclui operações em dia e operações com parcelas vencidas, excluindo os totalmente liquidados.",
  "costs-summary-card-operations-tooltip-overdue": "Quantidade de empréstimos contratados com pelo menos uma parcela em atraso (vencida e não liquidada, ou em aberto com vencimento anterior a hoje).",
  "costs-summary-card-operations-tooltip-settled": "Quantidade de empréstimos contratados cujas parcelas liquidáveis (exceto carência) estão todas quitadas.",
  "costs-summary-card-volume-tooltip-open": "Soma em BRL de todas as parcelas em aberto (em dia e vencidas), considerando os filtros aplicados (empresa, grupo, etc.).",
  "costs-summary-card-volume-tooltip-overdue": "Soma em BRL das parcelas em atraso (status vencido ou em aberto com vencimento passado), considerando os filtros aplicados.",
  "costs-summary-card-volume-tooltip-settled": "Soma em BRL das parcelas já liquidadas, considerando os filtros aplicados.",
  "costs-loan-types": "Tipos de empréstimo",
  "costs-credit-value": "Valor do crédito",
  "costs-credit-in-national-currency": "Crédito em moeda nacional",
  "costs-outstanding-balance-in-local-currency": "Saldo devedor em moeda nacional",
  "costs-last-installment-due-date-start": "Vencimento última parcela (inicio)",
  "costs-last-installment-due-date-end": "Vencimento última parcela (fim)",
  "costs-working-capital1": "Capital de Giro",
  "derivatives-settled-transactions": "Operações Liquidadas",
  "derivatives-hedge-position": "Posição de Hedge",
  "derivatives-report-error-title": "Erro ao gerar o relatório, tente novamente.",
  "derivatives-report-error-description": "Se o erro persistir, entre em contato com o suporte.",
  "derivatives-report-error-btn-suport": "Suporte",
  "derivatives-report-error-btn-try-again": "Tentar Novamente",
  "derivatives-report-success-title": "Relatório gerado com sucesso!",
  "derivatives-report-success-description": "Seu relatório foi baixado automaticamente. Encontre-o na pasta Downloads ou no local escolhido.",
  "derivatives-budget-rate": "",
  "derivatives-exchange-rate-exposure": "",
  "derivatives-exposure-currency": "",
  "document-padronization-document-padronization": "Padronização de Documentos",
  "document-padronization-notional1": "Notional",
  "effective-exchange-rate-select-at-least-one-request": "Selecione pelo menos uma demanda para visualizar as informações",
  "effective-exchange-rate-currency-effectiveness": "Câmbio Efetivo",
  "effective-exchange-rate-hedges": "Hedges",
  "effective-exchange-rate-currency-closure": "Fechamento de Câmbio",
  "effective-exchange-rate-cash-flow1": "Fluxo de caixa",
  "effective-exchange-rate-hedge-order": "Ordem do Hedge",
  "effective-exchange-rate-deadline-days1": "Prazo (Dias)",
  "effective-exchange-rate-price-ndf1": "Preço (NDF)",
  "effective-exchange-rate-cap-do-ndf": "CAP do NDF",
  "effective-exchange-rate-ptax-reversal": "PTAX/Reversão",
  "effective-exchange-rate-exchange-rate-effective-calculated": "Var. Câmbio Efetivo (Calculado)",
  "effective-exchange-rate-hedge-effective-exchange": "Câmbio Efetivo do Hedge",
  "effective-exchange-rate-exchange2": "Câmbio",
  "effective-exchange-rate-priced-exchange": "Câmbio Precificado",
  "effective-exchange-rate-cash-flow2": "Fluxo de Caixa",
  "effective-exchange-rate-effective-date": "Data Efetiva",
  "effective-exchange-rate-value-me": "Valor ME",
  "effective-exchange-rate-order-event": "Ordem Evento",
  "effective-exchange-rate-data-contract": "Data Contr.",
  "effective-exchange-rate-settlement-date1": "Data de liquidação",
  "effective-exchange-rate-exchange-budget": "Câmbio Orçamento",
  "effective-exchange-rate-accumulated-balance": "Saldo Acumulado",
  "general-open": "Abrir",
  "general-opened": "Aberto",
  "general-close": "Fechar",
  "general-closed": "Fechado",
  "general-submit-file": "Enviar Arquivo",
  "general-move": "Mover",
  "general-rename": "Renomear",
  "general-upload-files": "Carregar arquivos",
  "general-new-folder": "Nova Pasta",
  "general-not-informed": "Não informado",
  "general-insertion-date": "Data de inserção",
  "general-name": "Nome",
  "general-documents": "Documentos",
  "general-general-prasentation": "Apresentação Geral",
  "general-folder": "Pasta",
  "general-folders": "Pastas",
  "general-output": "Saida",
  "general-report-type": "Tipo de Relatório",
  "general-client": "Cliente",
  "general-insert": "Inserir",
  "general-save": "Salvar",
  "general-saving": "Salvando...",
  "general-cancel": "Cancelar",
  "general-send": "Enviar",
  "general-delete": "Deletar",
  "general-update": "Editar",
  "general-updated": "Atualizado",
  "general-loading": "Carregando",
  "general-network-error": "Erro de rede",
  "general-network-error-message": "Não foi possível falar com o servidor. Confira sua conexão e tente de novo em instantes.",
  "general-request-error": "Erro ao processar a requisição",
  "general-search": "Pesquisar",
  "general-dashboard": "Dashboard",
  "general-administration": "Administração",
  "general-settings": "Configurações",
  "general-logs": "Registros",
  "general-monitoring": "Monitoramento",
  "general-users": "Usuários",
  "general-duplicate": "Duplicar",
  "general-register": "Cadastro",
  "general-groups": "Grupos",
  "general-portuguese-br": "Português-BR",
  "general-spanish-es": "Espanhol-ES",
  "general-english-us": "Inglês-US",
  "general-active": "Ativo",
  "general-yes": "Sim",
  "general-no": "Não",
  "general-type-observation": "Digitar observação",
  "general-observation": "Observação",
  "general-observations": "Observações",
  "general-corporate-reason": "Razão Social",
  "general-cnpj": "CNPJ",
  "general-fantasy-n": "N.Fantasia",
  "general-fantasy-name": "Nome Fantasia",
  "general-optional": "Opcional",
  "general-institution": "Instituição",
  "general-surname": "Apelido",
  "general-user-or-email": "Usuário ou e-mail",
  "general-filter": "Filtrar",
  "general-filters": "Filtros",
  "general-clear": "Limpar",
  "general-apply": "Aplicar",
  "general-next": "Próximo",
  "general-confirm": "Confirmar",
  "general-form-invalid": "Fomulário inválido",
  "general-user": "Usuário",
  "general-month": "Mês",
  "general-year": "Ano",
  "general-day": "Dia",
  "general-actual": "Atual",
  "general-shopping": "Compras",
  "general-sofr": "SOFR",
  "general-derivatives-index": "Vencimentos de Derivativos (BRL) - Próximos 12 Meses (Notional × Forward Rate)",
  "general-cost-savings-comparison": "Comparativo de economia de custos",
  "general-bankability-score": "Score de bancabilidade",
  "general-good-credit-score": "Bom Score de Crédito",
  "general-economic-calendar": "Calendário Econômico",
  "general-available-credit-contracted": "Crédito Disponível x Contratado",
  "general-cdi": "CDI",
  "general-ipca": "IPCA",
  "general-time": "Horário",
  "general-event": "Evento",
  "general-real": "Real",
  "general-previous": "Anterior",
  "general-forecast": "Previsão",
  "general-address": "Endereço",
  "general-site": "Site",
  "general-your-browser-does-not-support-video": "Seu navegador não suporta vídeo",
  "general-required-field": "Campo requerido",
  "general-ok": "Ok",
  "general-file": "Arquivo",
  "general-files": "Arquivos",
  "general-size": "Tamanho",
  "general-to-go-back": "Voltar",
  "general-category": "Categoria",
  "general-review": "Revisar",
  "general-document": "Documento",
  "general-reject": "Rejeitar",
  "general-approve": "Aprovar",
  "general-download": "Download",
  "general-all": "Todos",
  "general-no-user-registered-for-selected-company": "Nenhum usuário cadastrado para empresa selecionada",
  "general-write-adescription": "Escreva uma descrição",
  "general-write-aname": "Escreva um nome",
  "general-description": "Descrição",
  "general-finalize": "Finalizar",
  "general-everything-is-fine": "Tudo certo!",
  "general-oops-something-went-wrong": "Oops, algo deu errado!",
  "general-actions": "Ações",
  "general-go-back": "Voltar",
  "general-shrink-expand": "Encolher/Expandir",
  "general-expand1": "Expandir",
  "general-shrink": "Encolher",
  "general-select1": "Selecionar",
  "general-uncheck": "Desmarcar",
  "general-export1": "Exportar",
  "general-operations-exported-successfully": "Operações exportadas com sucesso!",
  "general-edit": "Editar",
  "general-add-contact": "Adicionar Contato",
  "general-contact-name": "Nome do Contato",
  "general-telephone": "Telefone",
  "general-job-title": "Cargo",
  "general-email": "E-mail",
  "general-description1": "Descrição",
  "general-contacts": "Contatos",
  "general-data-loss-warning": "Todos os dados inseridos serão perdidos.",
  "general-global-limit": "Limite Global",
  "general-add": "Adicionar",
  "general-information-edited-successfully": "Informações editadas com sucesso!",
  "general-company": "Empresa",
  "general-limit-type": "Tipo de limite",
  "general-value": "Valor",
  "general-share": "Compartilhar",
  "general-list": "Listagem",
  "general-to-see": "Ver",
  "general-create": "Criar",
  "general-period": "Período",
  "general-select-month": "Selecione o mês",
  "general-select-year": "Selecione o ano",
  "general-expiration-period": "Período de Vencimento",
  "general-initial-data": "Data Inicial",
  "general-select-start-date": "Selecione a data inicial",
  "general-final-date": "Data Final",
  "general-select-end-date": "Selecione a data final",
  "general-operation-type1": "Tipo de Operação",
  "general-select-operation-type": "Selecione o tipo de operação",
  "general-output-format": "Formato de Saída",
  "general-generate-report": "Gerar Relatório",
  "general-select-customer": "Selecione o cliente",
  "general-cog-ai": "Cog IA",
  "general-remove": "Remover",
  "general-reference": "Referência",
  "general-asset-type": "Tipo do Ativo",
  "general-asset-description": "Descrição do Ativo",
  "general-assessed-value": "Valor Avaliado",
  "general-evaluation-date": "Data da Avaliação",
  "general-value-of-guarantee": "Valor da Garantia",
  "general-warranty-status": "Status da Garantia",
  "general-percentage-compromised": "% Comprometida",
  "general-control-module": "Controle",
  "general-performance-module": "Performance",
  "general-negotiation-moduke": "Negociação",
  "general-remove-uploaded-file": "Remover arquivo enviado",
  "general-confirm-file-removal": "Tem certeza que deseja remover o arquivo enviado?",
  "general-file-removed-successfully": "Arquivo removido com sucesso!",
  "general-social-contract-and-contractual-amendments-of-the-holding": "Contrato social e alterações contratuais da Holding",
  "general-holding-financial-statements-last3-years": "Demonstrações financeiras da Holding (03 últimos anos)",
  "general-de": "de",
  "general-files1": "arquivo(s)",
  "general-file-limit-reached": "Limite de arquivos atingido",
  "general-max-files-limit": "Você pode adicionar no máximo {maxFiles} arquivos.",
  "general-registration-date": "Data de Cadastro",
  "general-zip-code": "Cep",
  "general-city": "Cidade",
  "general-uf": "UF",
  "general-qualification": "Qualificação",
  "general-country": "país",
  "general-legal-representative": "Representante Legal",
  "general-qsa-receita-federal": "QSA - Receita Federal",
  "general-legal-representative-qualification": "Qualificação do Representante Legal",
  "general-no-records-found": "Nenhum registro encontrado",
  "general-sector1": "Setor",
  "general-site1": "Site",
  "general-remove-operation": "Remover operação",
  "general-invalid-cnpj": "CNPJ Inválido",
  "general-email-sent-successfully": "Email enviado com sucesso!",
  "general-registration-data": "Dados Cadastrais",
  "general-derivative": "Derivativo",
  "general-view-all": "Ver todos",
  "general-view-operation": "Visualizar Operação",
  "general-events-in": "Eventos em",
  "general-import-operations": "Importar operações",
  "general-extracting-operations": "Extraindo operações...",
  "general-send-file-or-text-to-extract-operations": "Envie um arquivo ou um texto para extrair as operações",
  "general-create-with-cog-ai": "Criar com COG AI",
  "general-drag-image-here-or-paste-from-clipboard": "Arraste uma imagem aqui ou cole da área de transferência",
  "general-start-from-image": "A partir de Imagem",
  "general-select-image": "Selecionar Imagem",
  "general-preview": "Prévia",
  "general-from-text": "A partir de texto",
  "general-operations-imported-successfully": "operações foram importadas com sucesso",
  "general-operations-not-imported-due-to-different-currencies": "operações não foram importadas pois são de moedas diferentes",
  "general-current-demand-currency": "da moeda atual da demanda",
  "general-selected-columns": "colunas selecionadas",
  "general-select-columns": "Selecione as colunas",
  "general-columns1": "Colunas",
  "general-parity": "Paridade",
  "general-operation-id": "Id Operação",
  "general-cap1": "tampa",
  "general-volume": "Volume",
  "general-future-value": "Valor Futuro",
  "general-select-bank-before-continue": "Selecione um banco antes de continuar.",
  "general-in-thousands": "em milhares",
  "general-create-operations-with-cog-ai": "Criar operações com Cog AI",
  "general-annual-hedge-cost-percentage": "Custo ao ano hedge %",
  "general-preparing-download": "Preparando Download",
  "general-downloading-file": "Baixando arquivo",
  "general-error-downloading": "Erro ao baixar",
  "general-compressing-files": "Compactando arquivos",
  "general-download-error": "Erro no processo de download",
  "general-error-generating-pdf": "Ocorreu um erro ao gerar o PDF",
  "general-generating-pdf1": "Gerando PDF...",
  "general-reports": "Relatórios",
  "general-generating-excel": "Gerando Excel...",
  "general-select-all": "Selecionar todos",
  "general-manage": "Gerenciar",
  "general-click-here-to-register": "Clique aqui para cadastrar",
  "general-current-time": "Horário Atual",
  "general-expiration-calendars": "Calendários de Vencimentos",
  "general-register1": "Cadastrar",
  "general-demand1": "Demanda",
  "general-purpose": "Finalidade",
  "general-status1": "Status",
  "general-currency1": "Moeda",
  "general-flow2": "Fluxo",
  "general-supplier1": "Fornecedor",
  "general-attach-contract": "Anexar Contrato",
  "general-agency-and-account": "Agência e Conta",
  "general-additional-costs1": "Custos Adicionais",
  "general-total-convertido": "Total Convertido",
  "general-bank-payer": "Banco Pagador",
  "general-country1": "País",
  "general-displaying": "Exibindo",
  "general-no-items-found": "Nenhum item encontrado",
  "general-data-contracting": "Data Contratação",
  "general-value2": "Valor",
  "general-in-development": "Em desenvolvimento",
  "general-feature-not-available": "Esta funcionalidade ainda não está disponível.",
  "general-select-company-to-start": "Para iniciar, selecione uma empresa",
  "general-start-modeling-select-company": "Para iniciar a modelagem, selecione uma empresa acima.",
  "general-launch-instalments": "Lançar Parcelas",
  "general-attention1": "Atenção!",
  "general-details1": "Detalhes",
  "general-demand-link-comex-loan": "Essa demanda precisa ser vinculado a um Comex ou Empréstimo",
  "general-responsible-user": "Usuário Responsável",
  "general-priority": "Prioridade",
  "general-expected-final-date": "Data prevista",
  "general-priority1": "Prioridade",
  "general-add-comment": "Adicionar Comentário",
  "general-delete-comment": "Excluir comentário",
  "general-expected-end-date": "Data prevista",
  "general-add-task": "Adicionar tarefa",
  "general-document-deleted-successfully": "Documento deletado com sucesso",
  "general-error-deleting-document": "Erro ao deletar documento",
  "general-operation-date-start": "Data da operação (início)",
  "general-operation-date-end": "Data da operação (fim)",
  "general-all-a": "Todas",
  "general-all-companies": "Todas empresas",
  "management-insertion-date": "Data da inserção",
  "management-reports": "Relatórios",
  "management-home": "Home",
  "management-onboarding": "Onboarding",
  "management-back-office": "Back Office",
  "management-document-analysis": "Análise de documentos",
  "management-data-room": "Data Room",
  "management-types-of-credit-limit": "Tipos de limite de crédito",
  "management-billing": "Faturamento",
  "management-loans": "Empréstimos",
  "management-no-loans-registered": "Nenhuma operação de empréstimo cadastrada",
  "management-cost": "Custo",
  "management-demands": "Demandas",
  "management-hedge-accounting": "Hedge accounting",
  "management-mark-to-market": "Marcação a Mercado (MtM)",
  "management-risk-management": "Gestão de riscos",
  "management-indebtedness": "Endividamento",
  "management-collateral-registry": "Garantias",
  "management-credit-demand": "Demanda de crédito",
  "management-debt-registry": "Cadastro de dívidas",
  "management-debt-report": "Relatório de dívidas",
  "management-debt-flow": "Fluxo de dívidas",
  "management-import-control": "Comex",
  "management-credit": "Crédito",
  "management-economic-analysis": "Análise econômica",
  "management-financial-statements": "DFP",
  "management-cash-flow-statement": "DFC",
  "management-income-statement": "DRE",
  "management-balance-sheet": "Balanço Patrimonial",
  "management-dashboard": "Dashboard",
  "management-assumptions": "Premissas",
  "management-projects": "Projetos",
  "management-scope": "Escopo",
  "management-physical-financial-schedule": "Cronograma físico financeiro",
  "management-cash-flow": "Fluxo de caixa",
  "management-financial-modeling": "Modelagem financeira",
  "management-business-case": "Business case",
  "management-project-finance": "Project finance",
  "management-market": "Mercado",
  "management-credit-operations-pipeline": "Pipeline de crédito",
  "management-bank-accounts": "Contas bancárias",
  "management-financial-institution": "Instituição Financeira",
  "management-financial-institutions": "Instituições Financeiras",
  "management-management": "Gerenciamento",
  "management-id": "Id",
  "management-name": "Nome",
  "management-compensation-code": "Cód. de Compensação",
  "management-description": "Descrição",
  "management-associates": "Associados",
  "management-users": "Usuários",
  "management-user": "Usuário",
  "management-status": "Status",
  "management-actions": "Ações",
  "management-clients": "Clientes",
  "management-data": "Data",
  "management-days": "Dias",
  "management-financial-institution-created-successfully": "Instituição financeira criada com sucesso",
  "management-financial-institution-updated-successfully": "Instituição financeira editada com sucesso",
  "management-financial-institution-deleted-successfully": "Instituição financeira removida com sucesso",
  "management-no-financial-institutions-registered": "Nenhuma instituição financeira cadastrada",
  "management-attachment-type": "Tipo de Anexo",
  "management-attachment-types": "Tipos de Anexo",
  "management-no-attachment-types-registered": "Nenhum tipo de anexo cadastrado",
  "management-add-attachment-type": "Adicionar tipo de anexo",
  "management-attachment-type-created-successfully": "Tipo de arquivo criado com sucesso",
  "management-attachment-type-updated-successfully": "Tipo de arquivo atualizado com sucesso",
  "management-attachment-type-deleted-successfully": "Tipo de arquivo removido com sucesso",
  "management-tenant": "Tenant",
  "management-tenants": "Tenants",
  "management-no-tenants-registered": "Nenhum Tenant cadastrado",
  "management-add-tenant": "Adicionar",
  "management-tenant-created-successfully": "Tenant criado com sucesso",
  "management-tenant-updated-successfully": "Tenant atualizado com sucesso",
  "management-tenant-deleted-successfully": "Tenant removido com sucesso",
  "management-financial-institution-title-delete-confirmation": "Tem certeza que deseja deletar essa instituição financeira?",
  "management-financial-institution-description-delete-confirmation": "A instituição financeira perderá todos os acessos ao sistema.",
  "management-attachment-type-title-delete-confirmation": "Tem certeza que deseja deletar esse tipo de anexo?",
  "management-attachment-type-description-delete-confirmation": "O tipo de anexo será removido do sistema.",
  "management-tenant-title-delete-confirmation": "Tem certeza que deseja deletar esse tenant?",
  "management-tenant-description-delete-confirmation": "O tenant será removido do sistema.",
  "management-company": "Empresa",
  "management-companys": "Empresas",
  "management-no-companys-registered": "Nenhum Empresa cadastrada",
  "management-add-company": "Adicionar Empresa",
  "management-company-created-successfully": "Empresa criada com sucesso",
  "management-company-updated-successfully": "Empresa atualizada com sucesso",
  "management-company-deleted-successfully": "Empresa removida com sucesso",
  "management-company-delete-confirmation-title": "Tem certeza que deseja deletar essa empresa?",
  "management-company-delete-confirmation-description": "A empresa será removido do sistema.",
  "management-company-all-companys": "Todas as empresas",
  "management-ndf-calculator": "Calculadora de NDF",
  "management-ndf-new-demand": "Nova demanda",
  "management-ndf-export-to-excel": "Exportar em Excel",
  "management-ndf-simulations": "Simulações",
  "management-ndf-listed": "Cotados",
  "management-ndf-contractors": "Contratados",
  "management-ndf-currency": "Moeda",
  "management-ndf-demands": "Demandas",
  "management-ndf-creation": "Criação",
  "management-derivatives": "Derivativos",
  "management-ndf-scenario": "Cenário",
  "management-ndf-scenarios": "Cenários",
  "management-ndf-new-scenario": "Novo cenário",
  "management-ndf-operation": "Operação",
  "management-ndf-operation-type": "Tipo de operação",
  "management-ndf-hired-operation": "Operações contratadas",
  "management-ndf-value": "Valor",
  "management-ndf-due-date": "Vencimento",
  "management-ndf-due-date-initial": "Data inicial do Vencimento",
  "management-ndf-due-date-final": "Data final do Vencimento",
  "management-ndf-reference": "Referência",
  "management-ndf-remarks": "Observações",
  "management-ndf-import": "Importação",
  "management-ndf-export": "Exportação",
  "management-ndf-loan": "Empréstimo",
  "management-ndf-pin-unpin": "Fixar/Desafixar",
  "management-ndf-add-trading-note": "Adicionar Nota de Negociação",
  "management-ndf-demand-management": "Gerenciamento de demandas",
  "management-ndf-operation-management": "Gerenciamento de operações",
  "management-ndf-quote": "Cotar",
  "management-ndf-quotation": "Cotação",
  "management-ndf-successfully-contracted": "Contratada com sucesso",
  "management-ndf-date-operations": "Data operação",
  "management-no-demand-registered": "Nenhuma demanda cadastrada",
  "management-ndf-deadline-days": "Prazo  em dias (corridos/úteis)",
  "management-ndf-calendar-days": "Dias corridos",
  "management-ndf-working-days": "Dias úteis",
  "management-ndf-exchange": "Câmbio",
  "management-ndf-rate": "Taxa",
  "management-ndf-to-hire": "Contratar",
  "management-ndf-demand": "Demanda",
  "management-ndf-add-simulation": "Adicionar simulação",
  "management-ndf-you-have": "Você tem",
  "management-ndf-bank": "Banco",
  "management-ndf-date-of-operation": "Data da operação",
  "management-ndf-notional": "Notional",
  "management-ndf-forward": "Forward",
  "management-ndf-forward-brl-me": "Forward (BRL/ME)",
  "management-ndf-volume-protected-up-to-cap": "Volume protegido até o CAP",
  "management-ndf-last-date-ptax-passed-cap": "Data que PTAX passou CAP",
  "management-ndf-reference-exchange": "Câmbio de referência",
  "management-ndf-notional-brl-by-reference": "Notional BRL pela Referência",
  "management-ndf-nominal-cost-brl": "Custo Nominal (BRL)",
  "management-ndf-nominal-cost": "Custo Nominal",
  "management-ndf-settlement-fee": "Taxa de Liquidação",
  "management-ndf-settlement-spot": "Spot",
  "management-ndf-add-scenario": "Adicionar cenário",
  "management-ndf-simulation": "Simulação",
  "management-ndf-select-the-bank": "Selecione o banco",
  "management-ndf-insert-date": "Inserir data",
  "management-ndf-enter-due-date": "Inserir vencimento",
  "management-ndf-insert-days": "Inserir dias",
  "management-ndf-insert-notional": "Inserir notional",
  "management-ndf-insert-forward": "Inserir forward",
  "management-ndf-insert-cap": "Inserir CAP",
  "management-ndf-to-compare": "Comparar",
  "management-ndf-cap": "CAP",
  "management-ndf-notional-flat": "Notional (flat)",
  "management-ndf-notional-aa": "Notional (a.a)",
  "management-ndf-create-demand": "Criar demanda",
  "management-ndf-create-simulation": "Criar simulação",
  "management-ndf-simulate": "Simular",
  "management-ndf-demand-is-invalid": "Demanda inválida",
  "management-ndf-simulation-is-invalid": "Simulação inválida",
  "management-ndf-derivative-information": "Informações do Derivativo",
  "management-ndf-deadline": "Prazo",
  "management-ndf-notion-me": "Notion (ME)",
  "management-ndf-new-operation": "Nova operação",
  "management-ndf-no-operation-registred": "Sem operações cadastradas",
  "management-ndf-derivatives-operations-management": "Gerenciamento de Operações de Derivativos",
  "management-ndf-derivatives-management": "Gerenciamento de derivativos",
  "management-ndf-quote-saved-successfully": "Cotação realizada com sucesso!",
  "management-ndf-hire-saved-successfully": "Contratação realizada com sucesso!",
  "management-ndf-reference-fees": "Taxas de Referência",
  "management-ndf-insert-fee": "Inserir taxa",
  "management-ndf-settle-operation": "Liquidar Operação",
  "management-ndf-finalize-settlement": "Finalizar Liquidação",
  "management-ndf-duplicate-simulation": "Simulação duplicada",
  "management-ndf-demand-simulation-created-successfully": "Demanda simulada criada com sucesso",
  "management-ndf-operations": "Operações",
  "management-ndf-demand-saved-successfully": "Demanda salva com sucesso!",
  "management-ndf-date-and-time": "Data e hora",
  "management-ndf-hire-quote": "Contratar",
  "management-ndf-settle-contract": "Liquidar contratação",
  "management-operation-title-delete-confirmation": "Tem certeza que deseja deletar essa operação?",
  "management-ndf-settlement-information": "Informações de liquidação",
  "management-ndf-add-settlement-note": "Adicionar nota de liquidação",
  "management-ndf-add-settlement-reversed": "Salvar Reversão",
  "management-ndf-add-settlement-reversed-title": "Clique para salvar a reversão da operação. Essa reversão gera uma cópia da operação atual, sem afetá-la.",
  "management-ndf-early-reversal-liquidation-success": "Reversão liquidada antecipadamente com sucesso",
  "management-ndf-early-reversal-liquidation-error": "Erro ao liquidar antecipadamente a reversão",
  "management-ndf-form-invalid": "Formulário inválido",
  "management-ndf-please-check-fields": "Por favor, verifique todos os campos obrigatórios",
  "management-ndf-no-response-received": "Nenhuma resposta recebida do servidor",
  "management-ndf-settlement-date": "Data da liquidação",
  "management-ndf-notional-settlement": "Notional da liquidação",
  "management-ndf-irrf": "IRRF",
  "management-ndf-irto-pay": "IR a pagar",
  "management-ndf-net-adjustment": "Ajuste líquido",
  "management-ndf-gross-adjustment": "Ajuste Bruto",
  "management-ndf-operation-successfully-selled": "Operação liquidada com sucesso",
  "management-ndf-simulated": "Simulado",
  "management-ndf-quoted": "Cotado",
  "management-ndf-hired": "Contratado",
  "management-ndf-demand-title-delete-confirmation": "Tem certeza que deseja deletar essa demanda?",
  "management-ndf-demand-deleted-successfully": "Demanda deletada com sucesso",
  "management-ndf-full-on-maturity": "Integral no vencimento",
  "management-ndf-before-maturity": "Integral antes do vencimento",
  "management-ndf-partial": "Parcial",
  "management-ndf-settlement-notional": "Notional liquidação",
  "management-error-loading-tenants": "Erro ao carregar tenants",
  "management-error-loading-tenant": "Erro ao carregar tenant",
  "management-error-removing-tenant": "Erro ao remover tenant",
  "management-error-creating-tenant": "Erro ao criar tenant",
  "management-error-updating-tenant": "Erro ao atualizar tenant",
  "management-error-loading-financial-institutions": "Erro ao carregar instituições financeiras",
  "management-error-loading-financial-institution": "Erro ao carregar instituição financeira",
  "management-error-removing-financial-institution": "Erro ao remover instituição financeira",
  "management-error-creating-financial-institution": "Erro ao criar instituição financeira",
  "management-error-updating-financial-institution": "Erro ao atualizar instituição financeira",
  "management-error-loading-companys": "Erro ao carregar empresas",
  "management-error-loading-company": "Erro ao carregar empresa",
  "management-error-removing-company": "Erro ao remover empresa",
  "management-error-creating-company": "Erro ao criar empresa",
  "management-error-updating-company": "Erro ao atualizar empresa",
  "management-error-loading-attachment-types": "Erro ao carregar tipos de anexo",
  "management-error-loading-attachment-type": "Erro ao carregar tipo de anexo",
  "management-error-removing-attachment-type": "Erro ao remover tipo de anexo",
  "management-attachment-type-removed-successfully": "Tipo de arquivo removido com sucesso",
  "management-error-creating-attachment-type": "Erro ao criar tipo de anexo",
  "management-error-updating-attachment-type": "Erro ao atualizar tipo de anexo",
  "management-error-loading-operations": "Erro ao carregar operações",
  "management-error-loading-operation": "Erro ao carregar operação",
  "management-error-removing-operation": "Erro ao remover operação",
  "management-operation-removed-successfully": "Operação removida com sucesso",
  "management-error-creating-operation": "Erro ao criar operação",
  "management-operation-created-successfully": "Operação criada com sucesso",
  "management-error-updating-operation": "Erro ao atualizar operação",
  "management-operation-updated-successfully": "Operação atualizada com sucesso",
  "management-error-loading-operations-status-count": "Erro ao carregar contagem de status de operações",
  "management-error-loading-previous-day-ptax": "Erro ao carregar PTAX do dia anterior",
  "management-error-loading-internacional-currencies": "Erro ao carregar moedas internacionais",
  "management-error-loading-operation-max-value": "Erro ao carregar valor máximo de operação",
  "management-error-loading-demands": "Erro ao carregar demandas",
  "management-error-loading-demand": "Erro ao carregar demanda",
  "management-error-removing-demand": "Erro ao remover demanda",
  "management-error-creating-demand": "Erro ao criar demanda",
  "management-demand-created-successfully": "Demanda criada com sucesso",
  "management-demand-simulation-created-successfully": "Simulação de demanda criada com sucesso",
  "management-error-updating-demand": "Erro ao atualizar demanda",
  "management-error-loading-demand-max-value": "Erro ao carregar valor máximo de demanda",
  "management-error-creating-demand-simulation": "Erro ao criar simulação de demanda",
  "management-error-calculating-due-date": "Erro ao calcular data de vencimento",
  "management-error-loading-highest-twelve-month-above-cap": "Erro ao carregar maior valor doze meses acima do CAP",
  "management-ndf-operation-status": "Status da operação",
  "management-ndf-financial-status": "Status financeiro",
  "management-ndf-composition": "Composição",
  "management-ndf-open": "Aberto",
  "management-ndf-settled": "Liquidado",
  "management-ndf-settled-reversed": "Reversão",
  "management-ndf-full": "Integral",
  "management-ndf-quotation-date-hour-confirmation": "Tem certeza que deseja confirmar a cotação em",
  "management-ndf-hire-date-hour-confirmation": "Tem certeza que deseja confirmar a contratação em",
  "management-ndf-time": "Hora",
  "management-ndf-origem": "Origem",
  "management-ndf-financial-operator": "Operador financeiro (Banco)",
  "management-ndf-revert-to-quoted": "Reverter para cotado",
  "management-ndf-revert-liquidated-to-open": "Reverter liquidado para aberto",
  "management-ndf-operation-reverted-successfully": "Operação revertida com sucesso",
  "management-ndf-error-reverting-operation": "Erro ao reverter operação",
  "management-ndf-operation-title-revert-liquidation-confirmation": "Tem certeza que deseja reverter a liquidação dessa operação?",
  "management-ndf-settlement-scenarios": "Cenários de liquidação",
  "management-ndf-settlement-exchange": "Câmbio de liquidação",
  "management-ndf-cost-per-year-per-scenario": "Custo ao ano por cenário",
  "management-ndf-cost-per-year-scenario-reference-exchange-rate": "Custo a.a por Cenários pelo Câmbio de Referência",
  "management-ndf-annual-cost": "Custo anual",
  "management-ndf-settlement-rate": "Taxa de Liquidação",
  "management-ndf-withholding-tax": "IRRF",
  "management-ndf-income-tax-payable": "IR a pagar",
  "management-see-operations": "Ver operações",
  "management-add-credit-limit-type": "Adicionar Tipo de Limite de Crédito",
  "management-no-credit-limit-type-founded": "Nenhum Tipo de Limite de Crédito cadastrado",
  "management-document-analysis-queue": "Esteira de análise de documentos",
  "management-error-loading-files": "Erro ao carregar arquivos",
  "management-company-name": "Nome da empresa",
  "management-documents-for-analysis": "Documentos para análise",
  "management-upload-date": "Data do upload",
  "management-finalize-analysis": "Finalizar análise",
  "management-save-without-approving-or-rejecting": "Salvar sem aprovar ou rejeitar",
  "management-under-review": "Em análise",
  "management-are-you-sure-you-want-to-reject": "Tem certeza que deseja rejeitar este documento?",
  "management-this-action-cannot-be-undone": "Esta ação não pode ser desfeita",
  "management-are-you-sure-you-want-to-finish": "Tem certeza que deseja finalizar?",
  "management-the-review-will-be-saved-nsent-to-customer": "A avaliação será salva e enviada para o cliente",
  "management-there-are-unrated-files": "Existem arquivos não avaliados!",
  "management-check-before-approving": "Verifique antes de aprovar",
  "management-preview-unavailable-download-file": "Pré-visualização indisponível. Faça o download do arquivo!",
  "management-document-rejected": "Documento rejeitado",
  "management-document-rejected-successfully": "Documento rejeitado com sucesso",
  "management-error-rejecting-document": "Erro ao rejeitar documento",
  "management-document-approved": "Documento aprovado",
  "management-document-approved-successfully": "Documento aprovado com sucesso",
  "management-error-approving-document": "Erro ao aprovar documento",
  "management-limit-type-registered-successfully": "Tipo de Limite cadastrado com sucesso!",
  "management-credit-limit-deleted-successfully": "limite de crédito excluído com sucesso!",
  "management-delete-credit-limit": "Excluir limite de crédito?",
  "management-confirm-delete-credit-limit": "Tem certeza que deseja excluir este limite de crédito?",
  "management-indicative": "Indicativa",
  "management-contracted-operations": "Com operações contratadas",
  "management-contracts-active-and-open": "Com operações contratadas e em aberto",
  "management-budget-rate1": "Câmbio de Contratação",
  "management-exchange-exhibition": "Exposição Cambial",
  "management-hedge-position1": "Posição de Hedge",
  "management-settled-operations": "Operações Liquidadas",
  "management-revert-to-simulated": "Reverter para Simulado",
  "management-status-reversion": "Reversão de status",
  "management-confirm-reversal-quotation-to-simulated": "Tem certeza que deseja reverter a cotação e definir o status dessa operação para Simulado?",
  "management-confirm-reverse-settlement-set-status-open": "Tem certeza que deseja reverter a liquidação e definir o status dessa operação para 'Contrado em Aberto'?",
  "management-confirm-revert-contract-status-quoted": "Tem certeza que deseja reverter a contratação e definir o status dessa operação para Cotado?",
  "management-operation-start-date": "Data inicial da operação",
  "management-operation-end-date": "Data final da operação",
  "management-search-data-receita-federal": "Buscar dados na Receita Federal",
  "management-unsaved-operations-warning": "Você selecionou operações não salvas, é preciso salvar a demanda antes.",
  "management-incomplete-fields-warning": "Atenção: existem campos não preenchidos ou operações incompletas. Finalize todos os itens antes de salvar.",
  "management-remove-operation-save-demand": "Para remover uma operação, salve a demanda antes.",
  "management-demand-type": "Tipo",
  "management-confirm-remove-operation": "Tem certeza que deseja remover essa operação da demanda?",
  "management-operations-removal-security": "Por segurança, somente operações no status 'Simulado' podem ser removidas.",
  "management-reject-document": "Rejeitar Documento",
  "management-approve-document": "Aprovar Documento",
  "management-approve-document-confirmation": "Tem certeza que deseja aprovar este documento?",
  "management-approve-all-documents": "Aprovar todos",
  "management-approve-all-documents-confirmation": "Todos os documentos pendentes desta empresa serão aprovados. Documentos já aprovados ou rejeitados não serão alterados, e nenhum e-mail será enviado ao cliente.",
  "management-approve-all-documents-success": "{{applied}} documento(s) aprovado(s)",
  "management-approve-all-documents-partial": "{{applied}} aprovado(s), {{failed}} com falha",
  "management-approve-all-documents-none-applied": "Nenhum documento foi aprovado",
  "management-approve-all-documents-skipped": "{{skipped}} documento(s) não alterado(s)",
  "management-error-sending-email-analysis-results": "Erro ao enviar email com resultado da análise dos documentos",
  "management-document-analysis1": "Análise de Documentos",
  "management-password-recovery-link": "Link Recuperação Senha",
  "management-send-email-password-recovery": "Enviar Email Recuperação Senha",
  "management-modality": "Modalidade",
  "management-monthly": "Mensal",
  "management-quarterly": "trimestral",
  "management-cost-consideration-low-strike": "Foi considerado o custo ao atingir o low strike. O custo pode variar conforme variação cambial.",
  "management-error-loading-di": "Erro ao carregar Di",
  "management-factor-di": "Fator DI",
  "management-derivative-management": "Derivativos",
  "management-derivative-demand-not-found": "Não foi possível encontrar a demanda de derivativo associada.",
  "management-derivative-operation-not-found": "Não foi possível encontrar a operação de derivativo associada.",
  "management-link-operation-to-loan-or-comex": "É necessário vincular esta operação a um Empréstimo ou Comex. Realize a associação antes de salvar as alterações.",
  "management-linked-installments": "parcelas vinculadas",
  "management-linked-installment": "parcela vinculada",
  "management-expiration1": "Vencimento",
  "management-link-installments": "Vincular parcelas",
  "management-ispb": "ISPB",
  "management-short-name": "Nome curto",
  "management-display-name": "Nome de exibição",
  "management-network": "Rede",
  "management-url": "URL",
  "management-revert-hiring": "Reverter contratação",
  "management-market-projection-curves": "Curvas de Projeção de Mercado",
  "market-customer-documents": "Documentos dos clientes",
  "market-customer-folders": "Pasta do cliente",
  "market-contract-folders": "Documentos de contrato",
  "market-no-folders-found": "Nenhuma pasta encontrada",
  "market-no-company-found": "Nenhuma empresa encontrada",
  "market-no-folders-documents-found": "Nenhuma pasta ou documento encontrado",
  "market-where-do-you-want-to-move": "Para onde quer mover?",
  "market-folder-created-successfully": "Pasta criada com sucesso!",
  "market-error-creating-folder": "Erro ao criar pasta!",
  "market-unable-to-create-new-folder": "Não foi possível criar uma nova pasta.",
  "market-file-renamed-successfully": "Arquivo renomeado com sucesso!",
  "market-error-renaming-file": "Erro ao renomear o arquivo!",
  "market-unable-to-rename-file": "Não foi possível renomear o arquivo",
  "market-file-moved-successfully": "Arquivo movido com sucesso!",
  "market-error-moving-file": "Não foi possível renomear o arquivo",
  "market-unable-to-move-file": "Não foi possível mover o arquivo",
  "market-upload-file-successfully": "Arquivo processado com sucesso!",
  "market-error-on-upload-file": "Erro ao tentar enviar arquivo",
  "market-unable-to-upload-file": "Não foi possível carregar arquivo",
  "market-folder-moved-successfully": "Pasta movida com sucesso!",
  "market-folder-renamed-successfully": "Pasta renomeda com sucesso!",
  "market-sending-file": "Enviando arquivo...",
  "market-create-bank-relationship": "",
  "market-register-bank-relationship": "Cadastrar Relacionamento Bancário",
  "market-account-info-and-contacts-linked": "Informações da conta e contatos vinculado",
  "market-account-number": "Número da Conta",
  "market-agency": "Agência",
  "market-bank": "Banco",
  "market-add-bank-account": "Adicionar Conta Bancária",
  "market-no-account-registered": "Nenhuma conta cadastrada",
  "market-credit-limit": "Limite de crédito",
  "market-add-distribution": "Adicionar Distribuição",
  "market-global-credit": "Crédito Global",
  "market-limit-distribution": "Distribuição do limite",
  "market-no-credit-limit-registered": "Nenhum limite de crédito cadastrado",
  "market-account": "Conta",
  "market-accounts-count": "Número de contas",
  "market-account-type": "Tipo de conta",
  "market-limit-type-registered-successfully": "Tipo de Limite cadastrado com sucesso!",
  "market-checking": "Conta Corrente",
  "market-savings": "Conta Poupança",
  "market-investment": "Conta de Investimento",
  "market-retirement": "Conta de Aposentadoria",
  "market-credit": "Conta de Crédito",
  "market-loan": "Conta de Empréstimo",
  "market-joint": "Conta Conjunta",
  "market-business": "Conta Empresarial",
  "market-student": "Conta Estudantil",
  "market-trust": "Conta de Truste",
  "market-payroll": "Conta Salário",
  "market-cash-management": "Conta de Gestão de Caixa",
  "market-foreign-currency": "Conta de Moeda Estrangeira",
  "market-crypto-currency": "Conta de Criptomoeda",
  "market-custodial": "Conta de Custódia",
  "market-broker": "Conta de Corretora",
  "market-charity": "Conta para Doações",
  "market-escrow": "Conta Escrow",
  "market-offshore": "Conta Offshore",
  "market-margin": "Conta de Margem",
  "market-government": "Conta Governamental",
  "market-virtual": "Conta Virtual",
  "market-other": "Outro",
  "market-bank-relationship1": "",
  "market-bank-relationship2": "",
  "market-bank-relationship3": "",
  "market-bank-relationship": "Relacionamento bancário",
  "market-no-bank-account-registered": "Nenhuma conta bancária cadastrada!",
  "market-delete-bank-relationship": "Excluir relacionamento bancário?",
  "market-confirm-delete-bank-relationship": "Tem certeza que deseja excluir este relacionamento bancário?",
  "market-bank-relationship-deleted-successfully": "Relacionamento bancário excluído com sucesso!",
  "market-delete-limit-distribution": "Excluir distribuição de limite?",
  "market-delete-limit-distribution-confirmation": "Tem certeza que deseja excluir esta distribuição de limite?",
  "market-limit-distribution-excluded-successfully": "Distribuição de limite excluída com sucesso!",
  "market-bank-account-registered-successfully": "Relacionamento bancário cadastrado com sucesso!",
  "market-limit-distribution-registered-successfully": "Distribuição de limite cadastrada com sucesso!",
  "market-limit-distribution-updated-successfully": "Distribuição de limite atualizada com sucesso!",
  "market-choose-financial-institutions": "Escolha as Instituições Financeiras",
  "market-shared-folder-success": "Pasta compartilhada com sucesso!",
  "market-bank-accounts-list": "Lista Contas Bancárias",
  "market-edit-bank-account": "Editar Conta Bancária",
  "market-company-documents": "Documentos da empresa",
  "market-company-files": "Arquivos da empresa",
  "market-link-copied-to-clipboard": "Link copiado para a área de transferência",
  "market-share-with-financial-institutions": "Compartilhar com todas as instituições financeiras",
  "market-select-at-least-one-bank": "Selecione pelo menos um banco",
  "market-download-selected": "Baixar Selecionados",
  "market-no-financial-institutions-registered1": "Nenhuma instituição financeira encontrada",
  "market-register-new-bank-relationship": "Cadastrar Novo Relacionamento Bancário",
  "market-add-limit-distribution": "Adicionar Distribuição de Limite",
  "market-digit": "Dígito",
  "negotiation-credit-pipeline": "Pipeline de Crédito",
  "negotiation-negotiations-in-progress": "Negociações em Andamento",
  "negotiation-new-negotiation": "Nova negociação",
  "negotiation-select-company-to-view-current-negotiations": "Selecione uma empresa para ver as negociações em andamento",
  "negotiation-add-negotiation": "Adicionar Negociação",
  "negotiation-reference-name1": "Referência",
  "negotiation-reason-for-negotiation": "Motivo da Negociação",
  "negotiation-next-action-required": "Próxima ação necessária",
  "negotiation-task-created-successfully": "Tarefa criada com sucesso",
  "negotiation-error-creating-task": "Erro ao criar task",
  "negotiation-comment-created-successfully": "Comentário criado com sucesso",
  "negotiation-error-creating-comment": "Erro ao criar comentário",
  "negotiation-document-created-successfully": "Documento criado com sucesso",
  "negotiation-error-creating-document": "Erro ao criar documento",
  "negotiation-negotiation-successfully-created": "Negociação criada com sucesso",
  "negotiation-error-creating-negotiation": "Erro ao criar negociação",
  "negotiation-negotiation-successfully-updated": "Negociação atualizada com sucesso",
  "negotiation-error-updating-negotiation": "Erro ao atualizar negociação",
  "negotiation-priority-changed-successfully": "Prioridade alterada com sucesso!",
  "negotiation-error-changing-negotiation-priority": "Erro ao mudar a prioridade da negociação",
  "negotiation-negotiation-successfully-deleted": "",
  "negotiation-negotiation-removed-successfully": "Negociação removida com sucesso",
  "negotiation-remove-negotiation": "Remover negociação?",
  "negotiation-confirm-remove-negotiation": "Tem certeza que deseja remover a negociação?",
  "negotiation-comment-deleted-successfully": "Comentário removido com sucesso",
  "negotiation-task-deleted-successfully": "Tarefa removida com sucesso",
  "onboarding-onboarding": "Onboarding",
  "onboarding-company-registration": "Cadastro de Empresa",
  "onboarding-company-registration-subtitle": "O cadastro e envio dos documentos da sua empresa é essencial para que possamos realizar uma análise detalhada. Isso permitirá o nosso trabalho junto aos bancos, garantindo a eficiência e a precisão em todas as etapas das soluções financeiras para o seu negócio.",
  "onboarding-progress": "Onboarding",
  "onboarding-company-information": "Informações da empresa ",
  "onboarding-contacts": "Contatos",
  "onboarding-document-upload": "Upload de Documentos da Empresa",
  "onboarding-uploading-general-documents": "Upload de Documentos Gerais",
  "onboarding-uploading-billing-documents": "Upload de Documentos de Faturamento",
  "onboarding-uploading-financial-statements": "Upload de Demonstrações Financeiras",
  "onboarding-uploading-projects": "Upload de Projetos",
  "onboarding-uploading-warranty-documents": "Upload de Documentos de Garantia",
  "onboarding-sector": "Setor",
  "onboarding-do-onboarding": "Realizar onboarding",
  "onboarding-onboarding-completed-successfully": "Onboarding concluído com sucesso",
  "onboarding-onboarding-saved-successfully": "Onboarding salvo com sucesso",
  "onboarding-onboarding-updated": "Onboarding atualizado",
  "onboarding-error-updating-onboarding": "Erro ao atualizar onboarding",
  "onboarding-company-contact-persons": "Pessoas de contato da empresa",
  "onboarding-accounting-contact-persons": "Pessoas de contato da contabilidade",
  "onboarding-financial-contact-persons": "Pessoas de contato dos bancos",
  "onboarding-area-position": "Área/Cargo",
  "onboarding-social-contract-contractual-changes": "Contrato social e alterações contratuais",
  "onboarding-documentation-legal-representatives": "Documentação dos representantes legais",
  "onboarding-income-tax-partners": "Imposto de renda dos sócios",
  "onboarding-corporate-structure-map": "Mapa estrutura societária",
  "onboarding-executive-organizational-chart": "Organograma executivo",
  "onboarding-have-holding-company": "Possui holding?",
  "onboarding-financial-statements-last3years": "Demonstrações financeiras (03 últimos anos)",
  "onboarding-invalid-file-max-size": "Arquivo inválido. Selecione um arquivo .pdf ou .xlsx de até 100 MB.",
  "onboarding-pdf-or-xlsx-files-up-to100-mb": "Arquivos em .pdf ou .xlsx com até 100 MB",
  "onboarding-pdf-xls-xlsx-xlsm-files-up-to100-mb": "Arquivos em .pdf, .xls, .xlsx ou .xlsm com até 100 MB",
  "onboarding-pdf-files-up-to100-mb": "Arquivos em .pdf com até 100 MB",
  "onboarding-pdf-xlsx-or-image-files-up-to100-mb": "Arquivos em .pdf, .xlsx ou imagem (.jpg, .png) com até 100 MB",
  "onboarding-pdf-xlsx-or-pptx-files-up-to100-mb": "Arquivos em .pdf, .xlsx ou .pptx com até 100 MB",
  "onboarding-xlsx-files-up-to100-mb": "Arquivos em .xlsx com até 100 MB",
  "onboarding-jpg-or-png-files-up-to100-mb": "Arquivos em .jpeg, .jpg ou .png com até 100 MB",
  "onboarding-pdf-or-pptx-files-up-to100-mb": "Arquivos em .pdf ou .pptx com até 100 MB",
  "onboarding-pptx-files-up-to100-mb": "Arquivos em .pptx com até 100 MB",
  "onboarding-required": "Obrigatório",
  "onboarding-optional": "Desejável",
  "onboarding-invalid-file": "Arquivo inválido",
  "onboarding-select-pd-xlsx-file-up100-mb": "Selecione um arquivo .pdf ou .xlsx de até 100 MB",
  "onboarding-market-studies": "Estudos de mercado",
  "onboarding-institutional-presentation": "Apresentação institucional",
  "onboarding-commercial-presentations": "Apresentações comerciais",
  "onboarding-presentations-information-products-services": "Apresentações e Informações sobre produtos e serviços",
  "onboarding-company-images-products-services": "Imagens da empresa, produtos e serviços",
  "onboarding-brand-manual": "Manual da marca",
  "onboarding-logos-vector-jpg-png-formats": "Logos em formatos de imagem",
  "onboarding-brand-pitch-deck": "Pitch deck da marca",
  "onboarding-annual-billing": "Faturamento Anual",
  "onboarding-partial-billing-current-year": "Faturamento parcial ano corrente",
  "onboarding-balance-sheet-income-statement-ddc": "Balanço, DRE e DFC",
  "onboarding-monthly-balance-sheets-last3-years": "Balancetes mensais últimos 3 anos",
  "onboarding-business-plan": "Plano de negócios",
  "onboarding-projections": "Projeções",
  "onboarding-multi-year-financial-projection": "Projeção financeira plurianual",
  "onboarding-backlog-with-balance-projection": "Backlog com saldo e projeção",
  "onboarding-debt": "Endividamento",
  "onboarding-debt-projection": "Projeção endividamento",
  "onboarding-edital": "Edital",
  "onboarding-loan-agreements": "Contratos de Empréstimo",
  "onboarding-physical-financial-schedule": "Cronograma físico-financeiro",
  "onboarding-consortium-incorporation-document-ia": "Documento de constituição de consórcio (se aplicável)",
  "onboarding-general-information-sae": "Informações gerais (estudos, análises, etc...)",
  "onboarding-properties-registrations-evaluations": "Imóveis: matrículas e avaliações",
  "onboarding-accounts-receivable-cdmr": "Contas a receber (consentimento, prazo, meio de recebimento...)",
  "onboarding-contracts-customers": "Contratos com clientes",
  "onboarding-send-onboarding": "Enviar onboarding",
  "onboarding-send-link": "Enviar link",
  "onboarding-choose-user-to-send-onboarding-link": "Escolher usuário para enviar link de onboarding",
  "onboarding-error-sending-onboarding-link": "Erro ao enviar link de onboarding",
  "onboarding-registration-completed": "Cadastro realizado",
  "onboarding-invitation-to-user-by-company-success": "O convite para o usuário {{ email }} foi enviado, ele irá receber um e-mail para validar os dados e assim que finalizar, vamos te notificar o status.",
  "onboarding-file-upload-success": "Arquivo enviado com sucesso!",
  "onboarding-company-documents1": "Documentos da Empresa",
  "onboarding-general-documents1": "Documentos Gerais",
  "onboarding-billing-documents1": "Documentos de Faturamento",
  "onboarding-financial-statements1": "Demonstrações Financeiras",
  "onboarding-projects1": "Projetos",
  "onboarding-warranty-documents1": "Documentos de Garantia",
  "onboarding-document-analysis2": "Análise de Documentos",
  "onboarding-mandatory-documents-submitted": "Todos os documentos obrigatórios enviados",
  "onboarding-documents-pending-delivery": "Existem documentos pendente de envio",
  "onboarding-all-documents-approved": "Todos documentos aprovados",
  "onboarding-documents-not-approved": "Documentos enviados ainda não aprovados",
  "onboarding-no-document-sent": "Nenhum documento enviado",
  "onboarding-approved1": "Aprovado",
  "onboarding-request-rejected": "Rejeitado",
  "onboarding-pending-analysis": "Pendente de análise",
  "onboarding-analyzed-by-user": "Analisado por {user} em {date}",
  "onboarding-sent-by-user-on-date": "Enviado por {user} em {date}",
  "onboarding-annual-revenue-previous-years": "Faturamento Anual (Anos Anteriores)",
  "onboarding-balance-dre-dfc-previous-years": "Balanço, DRE e DFC (Anos Anteriores)",
  "risk-panel-currency-expiration": "Moeda / Vencimento",
  "risk-panel-future-value-brazilian-real": "Valor Futuro (BRL)",
  "risk-panel-weighted-capital": "CAP Ponderado",
  "risk-panel-effective-current-loss-cap-brl": "Perda Efetiva Atual CAP (BRL)",
  "risk-panel-loss-percentage-current": "Perda % Atual",
  "risk-panel-scenario-brl": "Cenário (BRL)",
  "risk-panel-average-weighted-cost": "Média de Custo Ponderado",
  "risk-panel-partial-hedge-economy": "Ecônomia Hedge Parcial",
  "risk-panel-cap-exhibition": "Exposição do CAP",
  "risk-panel-monthly-exhibition": "Exposição mensal",
  "risk-panel-average-spot-ref": "Média de Spot Ref.",
  "risk-panel-average-price": "Média de Preço",
  "risk-panel-average-total-cost": "Média de Custo Total",
  "risk-panel-partial-hedge-economy-brl": "Economia BRL Hedge parcial",
  "risk-panel-average-cost-perfect-hedge": "Média de Custo Hedge Total",
  "risk-panel-average-margin-cap": "Média de Margem CAP",
  "risk-panel-current-parity": "Paridade Atual",
  "risk-panel-current-actual-loss-cap": "Perda Efetiva Atual CAP",
  "risk-panel-current-loss": "Perda Atual",
  "risk-panel-loss1": "Perda",
  "risk-panel-future-due-dates": "Vencimentos Futuros",
  "risk-panel-passive-future-due-dates": "Vencimentos Futuros Passivos",
  "risk-panel-realized-economy": "Economia Atual",
  "risk-panel-estimated-economy": "Economia Estimada",
  "risk-panel-synthetic-vision": "Visão Sintética",
  "risk-panel-total-volume": "Volume total",
  "risk-panel-net-result": "Resultado líquido",
  "risk-panel-partial-hedge-economics": "Economia hedge parcial",
  "risk-panel-average-term-in-days": "Prazo médio em dias",
  "risk-panel-current-loss-and-percentage": "Perda atual e %",
  "risk-panel-annual-hedge-cost": "Custo ao ano do hedge",
  "risk-panel-total-amount-and-protected-amount": "Exposição do CAP",
  "risk-panel-estimated-economy1": "Economia estimada",
  "risk-panel-future-value-vs-cap-vs-spot": "Valor futuro por vencimento vs CAP vs SPOT",
  "risk-panel-current-loss-estimate-vs-scenarios": "Estimativa de perda atual vs Cenários",
  "risk-panel-total-general-brl": "Total Geral BRL",
  "risk-panel-company-parity": "Empresa/Paridade",
  "risk-panel-margin-of-cap-percentage": "Margem do CAP (%)",
  "risk-panel-future-value-brl": "Valor Futuro (BRL)",
  "risk-panel-spot-ref1": "Spot. Ref.",
  "risk-panel-price-ndf": "Preço (NDF)",
  "risk-panel-total-cost-yearly-percentage": "Custo Total (a.a.) (%)",
  "risk-panel-partial-hedge-economy-brl1": "Economia BRL Hedge parcial (%)",
  "risk-panel-perfect-cost-brl": "Custo Perfeito (BRL)",
  "risk-panel-margin-cap-percentage": "Margem CAP (%)",
  "risk-panel-current-parity1": "Paridade Atual",
  "risk-panel-usd-pricing": "Precificação em USD",
  "risk-panel-current-effectively-lost-cap-brl": "Perda Efetiva Atual CAP (BRL)",
  "risk-panel-current-loss-percentage": "Perda Atual (%)",
  "risk-panel-loss-scenario": "Cenário de perda",
  "risk-panel-current-effective-loss-cap-pec": "Perda Efetiva Atual CAP (PEC)",
  "risk-panel-partial-hedge-economy-brl2": "Economia Hedge parcial (BRL)",
  "risk-panel-value-brazilian-reais-thousands": "Valor (Milhares de BRL)",
  "risk-panel-amount-not-protected": "Ultrapassado",
  "risk-panel-protected-amount1": "Não ultrapassado",
  "risk-panel-weighted-average": "CAP ponderado",
  "risk-panel-currency-fluctuation-sensitivity-slider": "Use este controle deslizante para ajustar a sensibilidade da variação das moedas",
  "risk-panel-sensitivity-parameters-visibility": "Aqui você pode ver os parâmetros de sensibilidade.",
  "risk-panel-exchange-rates-and-variations": "Aqui estão as taxas de câmbio e suas variações.",
  "risk-panel-select-desired-currency-pair-here": "Selecione o par de moedas desejado aqui.",
  "risk-panel-operation-type-choice-comex-loan": "Escolha o tipo de operação entre COMEX e Empréstimo.",
  "risk-panel-annual-hedge-cost-percentage1": "Informe o custo anual de hedge em percentual.",
  "risk-panel-estimated-annual-economy": "Economia anual estimada",
  "risk-panel-no-operations-for-selected-filters": "Não há operações para os filtros selecionados",
  "risk-panel-passive-future-expirations-id": "ID da Operação",
  "risk-panel-value-local-currency-input": "Entrada (BRL)",
  "risk-panel-value-local-currency-output": "Saída (BRL)",
  "risk-panel-conversion-tax": "Taxa de Conversão",
  "risk-panel-variation": "Variação (%)",
  "user-permission-insert": "Inserir",
  "user-permission-save": "Salvar",
  "user-permission-cancel": "Cancelar",
  "user-permission-delete": "Excluir",
  "user-permission-update": "Editar",
  "user-permission-no-group-registered": "Nenhum Grupo cadastrado",
  "user-users": "Usuários",
  "user-administration": "Administração",
  "user-all": "Todos",
  "user-active": "Ativo",
  "user-inactive": "Inativo",
  "user-disabled": "Desativado",
  "user-pending": "Pendente",
  "user-actives": "Ativos",
  "user-inactives": "Inativos",
  "user-disableds": "Desativados",
  "user-pendings": "Pendentes",
  "user-no-profile-registered": "Nenhum Perfil cadastrado",
  "user-to-add": "Adicionar",
  "user-add-user": "Adicionar usuário",
  "user-edit-user": "Editar usuário",
  "user-cancel": "Cancelar",
  "user-finish": "Finalizar",
  "user-information": "Informações",
  "user-user-type": "Tipo de usuário",
  "user-name": "Nome",
  "user-first-name": "Primeiro nome",
  "user-second-name": "Segundo nome",
  "user-lastname": "Sobrenome",
  "user-function": "Função",
  "user-profile": "Perfil",
  "user-email": "E-mail",
  "user-phone": "Telefone",
  "user-type": "Tipo",
  "user-localization": "Localização",
  "user-language": "Idioma",
  "user-date-format": "Formato de data",
  "user-time-format": "Formato de hora",
  "user-timezone": "Fuso Horário",
  "user-status": "Status",
  "user-select": "Selecione",
  "user-permissions-group": "Grupo de Permissões",
  "user-selected": "selecionado",
  "user-mark-all": "Todos",
  "user-new-group": "Novo grupo",
  "user-permissions": "Permissões",
  "user-tenant": "Tenant",
  "user-group-created-successfully": "Grupo de usuários criado com sucesso",
  "user-group-updated-successfully": "Grupo de usuários atualizado com sucesso",
  "user-group-deleted-successfully": "Grupo de usuários removido com sucesso",
  "user-user-created-successfully": "Usuario criado com sucesso",
  "user-user-updated-successfully": "Usuario atualizado com sucesso",
  "user-user-deleted-successfully": "Usuario removido com sucesso",
  "user-user-title-delete-confirmation": "Tem certeza que deseja deletar esse usuário?",
  "user-user-description-delete-confirmation": "O usuário perderá todos os acessos ao sistema.",
  "user-user-group-title-delete-confirmation": "Tem certeza que deseja deletar esse grupo?",
  "user-user-group-description-delete-confirmation": "O grupo será removido do sistema.",
  "user-user-error-loading-users": "Erro ao carregar usuários",
  "user-user-error-loading-user": "Erro ao carregar usuário",
  "user-user-error-removing-user": "Erro ao remover usuário",
  "user-user-error-loading-groups": "Erro ao carregar grupos",
  "user-user-error-loading-group": "Erro ao carregar grupo",
  "user-user-error-removing-group": "Erro ao remover grupo",
  "user-user-error-loading-roles": "Erro ao carregar papéis",
  "user-user-error-loading-role": "Erro ao carregar papel",
  "user-user-error-removing-role": "Erro ao remover papel",
  "user-user-error-loading-languages": "Erro ao carregar idiomas",
  "user-user-error-loading-date-formats": "Erro ao carregar formatos de data",
  "user-user-error-loading-time-formats": "Erro ao carregar formatos de hora",
  "user-user-error-loading-timezones": "Erro ao carregar fusos horários",
  "user-user-error-loading-permissions": "Erro ao carregar permissões",
  "user-user-error-loading-permission": "Erro ao carregar permissão",
  "user-user-error-removing-permission": "Erro ao remover permissão",
  "user-user-error-creating-user": "Erro ao criar usuário",
  "user-user-error-updating-user": "Erro ao atualizar usuário",
  "user-user-error-creating-permissions-group": "Erro ao criar grupo de permissões",
  "user-user-error-updating-permissions-group": "Erro ao atualizar grupo de permissões",
  "user-user-error-removing-permissions-group": "Erro ao remover grupo de permissões",
  "user-permissions-group-removed-successfully": "Grupo de permissões removido com sucesso",
  "user-change": "Alterar",
  "user-no-user-found": "Nenhum usuário encontrado",
  "user-manage-users": "Gerenciar Usuários",
  "user-last-login": "Último Login",
  "user-has-password": "Possui Senha",
  "validation-enter-valid-email": "Por favor, informe um e-mail válido",
  "validation-field-required": "Este campo é obrigatório",
  "validation-field-error": "Erro no campo",
  "validation-minlength": "O tamanho mínimo permitido é de {0} caracteres",
  "validation-maxlength": "O tamanho máximo permitido é de {0} caracteres",
  "validation-password-mismatch": "As senhas não conferem",
  "management-loan-operation-origins": "Origens de Operação de Crédito",
  "management-manage-external-origins": "Gerenciar Origens de Funding",
  "management-register-origin": "Cadastrar Origem",
  "management-no-origins-registered": "Nenhuma origem cadastrada",
  "management-register-first-origin-funding": "Cadastre a primeira origem de funding para esta instituição financeira.",
  "management-funding-origin": "Origem Funding",
  "management-select-origin": "Selecione a origem",
  "management-select-origin-funding-tooltip": "Selecione a origem do funding para esta operação.",
  "management-register-new": "Cadastrar novo",
  "management-edit-funding-origin": "Editar Origem Funding",
  "management-create-funding-origin": "Cadastrar Origem Funding",
  "management-country": "País",
  "management-enter-country": "Digite o país",
  "management-select-country": "Selecione o país",
  "management-select-country-first": "Selecione um país primeiro",
  "management-city": "Cidade",
  "management-enter-city-optional": "Digite a cidade (opcional)",
  "management-select-city-optional": "Selecione a cidade (opcional)",
  "management-country-field-required": "O campo país é obrigatório",
  "management-financial-institution-not-selected": "Instituição financeira não selecionada",
  "management-origin-updated-successfully": "Origem atualizada com sucesso",
  "management-origin-created-successfully": "Origem criada com sucesso",
  "management-error-updating-origin": "Houve um erro ao atualizar a origem",
  "management-error-creating-origin": "Houve um erro ao criar a origem",
  "management-delete-origin": "Excluir Origem",
  "management-confirm-delete-origin": "Deseja realmente excluir a origem \"{0}\"?",
  "management-origin-deleted-successfully": "Origem excluída com sucesso",
  "management-error-deleting-origin": "Erro ao excluir origem",
  "management-error-loading-origins": "Erro ao carregar origens"
}
